import { useField } from "formik";
import {
  Help,
  Control,
  Field as BulmaField,
  Checkbox
} from "react-bulma-components/src/components/form";
import { COLORS } from "../../constants";

export default props => {
  const [field, meta, helpers] = useField(props);
  const { touched, error } = meta;
  return (
    <BulmaField>
      <Control>
        <Checkbox
          {...field}
          placeholderText={props.placeholder || ""}
          color={props.color || COLORS.INFO}
          value="true"
          {...props}
        />
        &nbsp;{props.label ? props.label : null}
      </Control>
      {touched && error && <Help color={COLORS.DANGER}>{error}</Help>}
    </BulmaField>
  );
};
